import { Component, OnInit, OnDestroy } from '@angular/core';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { ActivatedRoute } from '@angular/router';
import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';

@Component({
  selector: 'app-moneris-checkout',
  templateUrl: './moneris-checkout.component.html',
  styleUrls: ['./moneris-checkout.component.scss']
})
export class MonerisCheckoutComponent implements OnInit {

  constructor(private avantoSession: AvantoSessionService, private route: ActivatedRoute, private avantoRoute: AvantoRoutingService) { }

  paymentReceived:boolean;
  errorMessage:string;

  ngOnInit() {
    if(this.route.snapshot.params['status'] == "success"){
      this.completeCheckout(); 
    }
    //If there is an error, the message will be passed as a GET parameter on the URL
    this.route.queryParams.subscribe(params=>{
      this.errorMessage = params.errMsg;
    })
  }

  goToCheckoutPage(){
    this.avantoRoute.goToCheckoutPage();
  }

  completeCheckout(){
    this.avantoSession.clearSession()
    .catch(() => {
      this.avantoSession.removeSessionFromCookie();
    })
    .finally(() => {
      this.avantoRoute.goToOrderCompletePage()
    })
  }

}
